import { render, staticRenderFns } from "./DeliveryPolicy.vue?vue&type=template&id=3d449929&scoped=true&"
import script from "./DeliveryPolicy.vue?vue&type=script&lang=js&"
export * from "./DeliveryPolicy.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryPolicy.vue?vue&type=style&index=0&id=3d449929&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d449929",
  null
  
)

export default component.exports